import { render } from "./PlayerCard.vue?vue&type=template&id=610edec8&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"

import "./PlayerCard.vue?vue&type=style&index=0&id=610edec8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610edec8"]])

export default __exports__